<template>
  <div>
    <!-- 产品增加 -->
    <!-- <el-dialog :title="operate === 'edit' ? '编辑产品' : '添加产品'" :close-on-click-modal="false"
      class="imgbox" width="1000px" :append-to-body="true" :before-close="closeDialog" @close="close"> -->
    <el-form label-width="110px" ref="ruleForm1" :rules="rules" :model="form">
      <el-form-item label="产品名称" prop="productName">
        <el-input v-model.trim="form.productName" autocomplete="off"></el-input>
      </el-form-item>

      <div class="item-row">
        <div class="item-ele">
          <el-form-item label="产品标识符" :required="status">
            <el-radio-group v-model="tag">
              <el-radio :label="0">平台生成</el-radio>
              <el-radio :label="1">自定义标识符</el-radio>
            </el-radio-group>
            <el-row v-if="tag === 1">
              <el-form-item prop="productKey">
                <el-input placeholder="请输入产品标识符" v-model.trim="form.productKey" v-focus>
                </el-input>
              </el-form-item>
            </el-row>
          </el-form-item>
        </div>
        <div class="item-ele">
          <el-form-item label="物模型类型" prop="productModelType">
            <el-radio-group v-model="form.productModelType">
              <el-radio :label="0">标准品类物模型</el-radio>
              <el-radio :label="1">自定义物模型</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
      </div>

      <div class="item-row">
        <div class="item-ele">
          <el-form-item label="产品品类" prop="categoryId">
            <div style="display: flex;">
              <el-select v-model="language" style="width: 80px;" @change="categoryChange">
                <el-option v-for="item in languageOpts" :key="item.language" :label="item.label" :value="item.value">
                </el-option>
              </el-select>

              <el-select v-model="form.categoryId" style="width: 150px;" filterable>
                <el-option v-for="item in categoryOpts" :key="item.categoryId" :label="item.categoryName"
                  :value="item.categoryId">
                </el-option>
              </el-select>

              <!-- <el-input v-if="operate === 'edit'" readonly ref="categoryInput" placeholder="请选择标准品类"
                suffix-icon="el-icon-arrow-down" v-model="categoryName">
              </el-input>
              <el-input v-else readonly @focus="focusStatus && openDrawer()" ref="categoryInput" placeholder="请选择标准品类"
                suffix-icon="el-icon-arrow-down" v-model="categoryName">
              </el-input> -->
            </div>
          </el-form-item>
        </div>
        <div class="item-ele">
          <el-form-item label="节点类型" prop="nodeType">
            <el-select :disabled="operate === 'edit'" v-model="form.nodeType" placeholder="请选择节点类型">
              <el-option v-for="item in nodeTypeOptions" :key="item.nodeTypeKey" :label="item.nodeTypeName"
                :value="item.nodeTypeKey">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="item-ele">
          <el-form-item label="连网方式" prop="connectionType">
            <el-select :disabled="operate === 'edit'" v-model="form.connectionType" placeholder="请选择连网方式">
              <el-option v-for="item in connectionTypeOptions" :key="item.connectionTypeKey"
                :label="item.connectionTypeName" :value="item.connectionTypeKey">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>

      <div class="item-row">
        <div class="item-ele">
          <el-form-item label="数据格式" prop="dataFormat">
            <el-select :disabled="operate === 'edit'" v-model="form.dataFormat" placeholder="请选择数据格式">
              <el-option v-for="item in dataFormatOptions" :key="item.dataFormatKey" :label="item.dataFormatName"
                :value="item.dataFormatKey">
              </el-option>
            </el-select>
          </el-form-item>
        </div>

        <div class="item-ele">
          <el-form-item label="认证方式" prop="authType">
            <el-select v-model="form.authType" placeholder="请选择认证方式">
              <el-option v-for="item in authTypeOptions" :key="item.authTypeKey" :label="item.authTypeName"
                :value="item.authTypeKey">

              </el-option>
            </el-select>
          </el-form-item>
        </div>

        <div class="item-ele">
          <el-form-item label="认证是否私有" prop="isPrivate" v-if="form.authType === 1">
            <el-radio-group v-model="form.isPrivate">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
      </div>

      <div class="item-row">
        <div class="item-ele">
          <el-form-item label="厂商" prop="vendorId">
            <el-select v-model="form.vendorId" placeholder="请选择厂商">
              <el-option v-for="item in vendorOpts" :key="item.vendorId" :label="item.dataFormatName"
                :value="item.vendorId">
              </el-option>
            </el-select>
          </el-form-item>
        </div>

        <div class="item-ele">
          <el-form-item label="型号" prop="vendorModelId">
            <el-select v-model="form.vendorModelId" placeholder="请选择型号">
              <el-option v-for="item in modelOpts" :key="item.vendorModelId" :label="item.vendorModelName"
                :value="item.vendorModelId">
              </el-option>
            </el-select>
          </el-form-item>
        </div>

        <div class="item-ele">
          <div class="item-ele">
            <el-form-item label="设备场景" prop="isActionDevice">
              <el-select v-model="form.isActionDevice" placeholder="请选择型号">
                <el-option v-for="item in isActionDeviceOpt" :key="item.value" :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
      </div>


      <!-- <el-form-item label="产品描述">
        <el-input type="textarea" resize="none" :rows="3" v-model="form.productDescription" :maxlength="255"
          show-word-limit></el-input>
      </el-form-item>

      <el-form-item label="离线提示语">
        <el-input type="textarea" resize="none" :rows="3" v-model="form.offlineInstructions" :maxlength="255"
          show-word-limit></el-input>
      </el-form-item> -->

    </el-form>
    <!-- <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="nextStep">下一步</el-button>
      </div> -->
    </el-dialog>
    <ChooseTypeDrawe v-if="drawerFlag" :drawerFlag="drawerFlag" @closeDrawer="closeDrawer" @getData="receive" />
  </div>
</template>
<script>
// import { addProduct } from '@/api/productRegistration'
import ChooseTypeDrawe from '@/components/product_control/chooseTypeDrawe'
import eventBus from '@/assets/js/eventBus'
import { categoryPage } from '@/api/categoryManager'
import { vendorList, modelList } from '@/api/productControl'
export default {
  props: {
    operate: {
      type: String
    },
    currentStep: {
      type: Number
    },
    productDetail: {
      type: Object
    }
  },
  components: {
    ChooseTypeDrawe
  },
  data() {
    const inputFocus = (rule, value, callback) => {
      if (this.form.categoryParentId === '' && this.form.categoryId === '') {
        callback(new Error('请选择产品品类'))
      } else {
        callback()
      }
    }
    const inputProductKey = (rule, value, callback) => {
      const reg = /^[A-Za-z0-9]+$/
      if (this.tag === 1) {
        if (this.form.productKey === '') {
          callback(new Error('产品标识不能为空'))
        } else if (this.form.productKey.length < 11) {
          callback(new Error('产品标识字符长度不得小于11'))
        } else if (this.form.productKey.length > 32) {
          callback(new Error('产品标识字符长度不得超过32个'))
        } else if (!reg.test(this.form.productKey)) {
          callback(new Error('产品标识只能由大小写字母，数字组成'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      tag: 0,
      categoryName: '',
      form: {
        productName: '', // 产品名称
        productKey: '', // 产品标识
        productModelType: 0, // 产品品类
        categoryParentId: '', // 父级ID
        categoryId: '', // 子品类id
        nodeType: '', // 节点类型
        connectionType: '', // 连网方式
        dataFormat: 0, // 数据格式
        authType: 1, // 认证方式
        isPrivate: 1, // 认证是否私有
        productDescription: '', // 描述
        offlineInstructions: '', // 离线提示语
        vendorId: '', // 厂商
        vendorModelId: '', // 型号
        isActionDevice: 1 // 设备场景类型
      },
      languageOpts: [{
        value: 0,
        label: '中文'
      }, {
        value: 1,
        label: '英文'
      }],
      language: 0,
      categoryOpts: [],
      rules: {
        productName: [
          { required: true, message: '请输入产品名称', trigger: 'blur' }
        ],
        productModelType: [
          { required: true, message: '请选择产品物模型类型', trigger: 'change' }
        ],
        isActionDevice: [
          { required: true, message: '请选择设备场景', trigger: 'change' }
        ],
        categoryId: [
          { required: true, message: '请选择产品品类', trigger: 'change' }
        ],
        vendorId: [
          { required: true, message: '请选择厂商', trigger: 'change' }
        ],
        vendorModelId: [
          { required: true, message: '请选择型号', trigger: 'change' }
        ],
        productKey: [
          { validator: inputProductKey, trigger: 'blur' }
        ],
        nodeType: [
          { required: true, message: '请选择节点类型', trigger: 'change' }
        ],
        connectionType: [
          { required: true, message: '请选择连网方式', trigger: 'change' }
        ],
        dataFormat: [
          { required: true, message: '请选择数据格式', trigger: 'change' }
        ],
        authType: [
          { required: true, message: '请选择认证方式', trigger: 'change' }
        ],
        isPrivate: [
          { required: true, message: '认证是否私有', trigger: 'change' }
        ]
      },
      focusStatus: true,
      autosize: { minRows: 6 }, // 设置textarea的最小高度
      nodeTypeOptions: [
        {
          nodeTypeName: '直连设备',
          nodeTypeKey: 0
        },
        {
          nodeTypeName: '网关子设备',
          nodeTypeKey: 1
        },
        {
          nodeTypeName: '网关设备',
          nodeTypeKey: 2
        }
      ],
      connectionTypeOptions: [
        {
          connectionTypeName: 'Wi-Fi',
          connectionTypeKey: 1
        },
        {
          connectionTypeName: 'Zigbee',
          connectionTypeKey: 2
        },
        {
          connectionTypeName: '蓝牙',
          connectionTypeKey: 3
        },
        {
          connectionTypeName: '蜂窝网(2G/3G/4G/5G)', // 蜂窝网ETHERNET
          connectionTypeKey: '4'
        },
        {
          connectionTypeName: '以太网',
          connectionTypeKey: '5'
        },
        {
          connectionTypeName: 'LiRaWAN',
          connectionTypeKey: '6'
        },
        {
          connectionTypeName: '其他',
          connectionTypeKey: '7'
        }
      ],
      dataFormatOptions: [
        {
          dataFormatName: 'ICA标准数据格式(Alink JSON)',
          dataFormatKey: 0
        },
        {
          dataFormatName: '透传/自定义',
          dataFormatKey: 1
        }
      ],
      authTypeOptions: [
        {
          authTypeName: '设备密钥',
          authTypeKey: 0
        },
        {
          authTypeName: 'X.509证书',
          authTypeKey: 1
        }
      ],
      drawerFlag: false, // 抽屉开关
      status: false,

      vendorOpts: [],
      modelOpts: [],
      isActionDeviceOpt: [{
        value: 1,
        label: '1-触发设备'
      }, {
        value: 2,
        label: '2-执行设备'
      }, {
        value: 3,
        label: '3-非触发设备和执行设备'
      }, {
        value: 4,
        label: '4-触发和执行设备'
      }]
    }
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.querySelector('input').focus()
      }
    }
  },
  created() {
    this.getCateGoryList();
    this.vendorListHandle();
    this.modelListHandle();
    eventBus.$on('resetFields', this.resetFields)
    eventBus.$on('validateStep1', this.validateStep1)
    // 编辑的时候，需要初始化数据
    if (this.operate === 'edit') {
      this.initData()
    }
  },
  watch: {
    tag: {
      handler(val) {
        if (val === 0) {
          console.log('不需要验证')
          this.status = false
        } else {
          this.status = true
        }
      }
    }
  },
  methods: {
    vendorListHandle() {
      const params = {}
      vendorList(params).then(res => {
        debugger;
        this.vendorOpts = res.data.data.list;
      })
    },
    modelListHandle() {
      const params = {}
      modelList(params).then(res => {
        this.modelOpts = res.data.data.list;
      })
    },
    categoryChange() {
      this.form.categoryId = '';
      this.getCateGoryList();
    },
    getCateGoryList() {
      const params = {
        pageNumber: 1,
        pageSize: 999,
        language: this.language
      }
      categoryPage({ params }).then((res) => {
        debugger;
        this.categoryOpts = res.data.data.list;
      })
    },
    close() {
      // this.tag = 0
      // this.form.productKey = ''
      // this.categoryName = ''
      // this.form.productDescription = ''
      // this.$refs.ruleForm1.resetFields()
    },
    initData() {
      const initFormData = {
        productName: this.productDetail.productName, // 产品名称
        productKey: this.productDetail.productKey, // 产品标识
        productModelType: this.productDetail.productModelType, // 产品品类
        categoryParentId: this.productDetail.categoryParentId, // 父级ID
        categoryId: this.productDetail.categoryId, // 子品类id
        nodeType: this.productDetail.nodeType, // 节点类型
        connectionType: this.productDetail.connectionType, // 连网方式
        dataFormat: this.productDetail.dataFormat, // 数据格式
        authType: this.productDetail.authType, // 认证方式
        isPrivate: this.productDetail.isPrivate, // 认证是否私有
        productDescription: this.productDetail.productDescription, // 描述 
        offlineInstructions: this.productDetail.offlineInstructions // 离线提示语 
      }
      this.form = initFormData
      console.log('initdata:', this.form)
    },
    resetFields() {
      if (this.$refs.ruleForm1) {
        this.$refs.ruleForm1.resetFields()
      }
    },
    closeDialog() {
      this.$refs.ruleForm1.resetFields()
      this.form.productDescription = ''
      this.categoryName = ''
      this.$emit('closeDialog')
    },
    // 提交
    nextStep() {
      return new Promise((resolve, reject) => {
        this.$refs.ruleForm1.validate((valid) => {
          if (valid) { // 验证成功
            console.log('productDetail', this.productDetail)
            console.log('form', this.form)
            Object.assign(this.productDetail, this.form)
            if (this.tag === 0) {
              delete this.productDetail.productKey
            }
            // console.log('this.productDetail:', this.productDetail)
            // // this.$emit('nextStep', 2)
            resolve(true)
          } else {
            resolve(false)
          }
        })
      })
    },
    // 重置
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    // 打开抽屉
    openDrawer(e) {
      this.drawerFlag = true
      this.focusStatus = false
    },
    // 关闭抽屉
    closeDrawer() {
      this.drawerFlag = false
      this.focusStatus = true
    },
    // 获取抽屉传过来的值
    receive(val) {
      console.log('子组件数据', val)
      this.form.categoryId = val.categoryId
      this.form.categoryParentId = val.categoryParentId
      this.categoryName = val.categoryName
      this.drawerFlag = false
      this.focusStatus = true
    }
  }
}
</script>

<style lang='less' scoped>
.item-row {
  display: flex;

  .item-ele {
    flex: 1;
  }
}
</style>
